import { WidgetId } from 'types/idTypes';
import { FormState, InteractionSumbissionState } from 'types/interaction.type';

import { RootState } from './store';

export const selectInteractionSubmissionState = (state: RootState): InteractionSumbissionState => state.interactions;

export const selectFormState =
  (widgetId: WidgetId) =>
  (state: RootState): FormState =>
    state.interactions.forms[widgetId];
